import { styled, css } from '@vebox/etui-system';
import { _ as _objectWithoutProperties, a as _objectSpread2 } from './_rollupPluginBabelHelpers-3b7bd988.js';
import { Td as Td$1 } from '@vebox/etui-system-elements';

const _excluded = ["theme"];
const Td = styled(Td$1).attrs(_ref => {
  var _props$className;
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const isEllipsis = (_props$className = props.className) === null || _props$className === void 0 ? void 0 : _props$className.includes('danfoss-table-cell-ellipsis');
  return _objectSpread2({
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSizeBase,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.text.primary,
    p: `${theme.spacing.xs}px ${theme.spacing.sm}px`,
    borderBottom: `1px solid ${theme.palette.divider}`,
    whiteSpace: 'nowrap',
    bg: theme.palette.common.white,
    isEllipsis
  }, props);
})`
  ${({
  isEllipsis
}) => isEllipsis && css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `};
`;

export { Td as T };
